import { Box, LinearProgress, Typography } from '@mui/material'
import { colors } from '@resiliatech/birdsong'

interface ChartProgressProps {
  chartProgress: number
}

export const ChartProgress = ({ chartProgress }: ChartProgressProps) => (
  <Box color={`${colors.success.dark}`}>
    <LinearProgress
      variant='determinate'
      value={chartProgress}
      sx={{
        height: 8,
        borderRadius: 3,
      }}
      color='inherit'
    />
    <Typography variant='caption' color='textSecondary'>
      {chartProgress.toFixed(2)}% of the way to your target
    </Typography>
  </Box>
)
